export const getJobsAPI="/jobs";
export const getAllJobSuggestionsAPI="/jobs/suggestions";
export function getJobAPI(id){ return "/jobs/"+id;}
export function getJobSuggestionsAPI(id){ return "/jobs/"+id+"/suggestions";}
export function sendJobApplicationAPI(id){ return "/jobs/"+id+"/apply";}
export function sendJobFeedbackAPI(id){ return "/jobs/"+id+"/feedback";}
export const getAppliedJobsAPI="/jobs/applied-jobs";
export const getJobFieldsAPI="/jobs/fields";
export const sendTrainerResumeAPI="/trainers-resumes";
